import React from "react"

import * as s from "./QuantitySelector.module.scss"

export const QuantitySelector = ({
  quantity,
  updateIncreaseQuantity,
  updateDecreaseQuantity,
  updateQuantity,
}) => {
  if (updateQuantity) {
    return (
      <div className={s.QuantitySelector}>
        <button 
          aria-label="Decrease quantity by 1"
          className={s.QuantitySelector__button}
          onClick={() => updateQuantity(-1)}
          onKeyDown={e => e.key === "Enter" && updateQuantity(-1)}
          tabIndex="0"
        >
          <span>-</span>
        </button>

        <div className={s.QuantitySelector__value}>
          <span>{quantity}</span>
        </div>

        <button 
          aria-label="Increase quantity by 1"
          className={s.QuantitySelector__button}
          onClick={() => updateQuantity(1)}
          onKeyDown={e => e.key === "Enter" && updateQuantity(1)}
          tabIndex="0"
        >
          <span>+</span>
        </button>
      </div>
    )
  } else if (updateDecreaseQuantity && updateIncreaseQuantity) {
    return (
      <div className={s.QuantitySelector}>
        {quantity > 1 ? (
          <button 
            aria-label="Decrease quantity by 1"
            className={s.QuantitySelector__button}
            onClick={() => updateDecreaseQuantity()}
            onKeyDown={e => e.key === "Enter" && updateDecreaseQuantity()}
            tabIndex="0"
          >
            <span>-</span>
          </button>
        ) : (
          <button 
            aria-label="Decrease quantity by 1"
            className={`${s.QuantitySelector__button} ${s.QuantitySelector__inActive}`}
            tabIndex="0"
          >
            <span>-</span>
          </button>
        )}

        <div className={s.QuantitySelector__value}>
          <span>{quantity}</span>
        </div>

        <button 
          aria-label="Increase quantity by 1"
          className={s.QuantitySelector__button}
          onClick={() => updateIncreaseQuantity()}
          onKeyDown={e => e.key === "Enter" && updateIncreaseQuantity()}
          tabIndex="0"
        >
          <span>+</span>
        </button>
      </div>
    )
  }
}
